var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notranslate",class:{ 
    dawn: _vm.skytime == 'dawn', 
    day: _vm.skytime == 'day',
    dusk: _vm.skytime == 'dusk',
    night: _vm.skytime == 'night',
    mobile: _vm.isMobile,
  },attrs:{"id":"app"}},[_c('Architecture',{ref:"architecture",attrs:{"slug":_vm.slug,"menu":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }